import React, { useLayoutEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import SunbaeBriefingBranchPc from './designcomponents/sunbaebriefingbranchpc';
import SunbaeBriefingBranchMobile from './designcomponents/sunbaebriefingbranchmobile';
import { DONGTAN_CONFIG } from '../lib/briefingBranchConfig';

export default function SunbaeBriefingDongtan() {
  useLayoutEffect(() => { window.scrollTo(0, 0); }, []);
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  return isMobile
    ? <SunbaeBriefingBranchMobile config={DONGTAN_CONFIG} />
    : <SunbaeBriefingBranchPc config={DONGTAN_CONFIG} />;
}
